// Asset Types
const productImagesAssetGql = /* GraphQL */ `
... on productImages_Asset {
    image:galleryEnlarged {
        srcset
        srcWebp
    }
}`;
const landingPageImagesAssetGql = /* GraphQL */ `
... on landingPageImages_Asset {
    image:lpImageTextUncropped {
        srcWebp
        srcset
    }
}`;
const imageAssetGql = /* GraphQL */ `
... on images_Asset {
    image: galleryEnlarged {
        srcWebp
        srcset
    }
}`;
const blogAssetGql = /* GraphQL */ `
... on blogNews_Asset {
    image:blogNewsUncropped {
        srcWebp
        srcset
    }
}`;

// Field Types
const productFeaturedImageGql = /* GraphQL */ `            
featuredImage:productFeaturedImage {
    ${productImagesAssetGql}
    ${imageAssetGql}
}`;
const blogFeaturedImageGql = /* GraphQL */ `
featuredImage:blogFeaturedImage {
    ${blogAssetGql}
    ${imageAssetGql}
}`;
const landingPageFeaturedImageGql = /* GraphQL */ `
featuredImage:landingPageFeaturedImage {
    ${landingPageImagesAssetGql}
    ${imageAssetGql}
}`;

// Content Grid Query
export const contentGridGql = /* GraphQL */ `
... on bodyContent2022_contentGrid_BlockType {
    typeHandle
    title:contentGridTitle
    theme:contentGridTheme
    gridItems {
        ... on gridItems_BlockType {
            itemEntry {
                url
                title
                ... on product_productPage_Entry {
                    ${productFeaturedImageGql}
                }
                ... on product_productPage2022_Entry {
                    ${productFeaturedImageGql}
                }
                ... on blog_blog_Entry {
                    ${blogFeaturedImageGql}
                }
                ... on blog_customerStory_Entry {
                    ${blogFeaturedImageGql}
                }
                ... on landingPage_landingPage_Entry {
                    ${landingPageFeaturedImageGql}
                }
                ... on landingPage_landingPage2023_Entry {
                    ${landingPageFeaturedImageGql}
                }
                ... on pressRelease_pressRelease_Entry {
                    ${blogFeaturedImageGql}
                }
            }
            itemTitle
            itemDescription
            itemImage {
                ${landingPageImagesAssetGql}
                ${imageAssetGql}
                ${productImagesAssetGql}
                ${blogAssetGql}
            }
        }
    }
}`;
